import { useMatch } from 'react-router-dom';
import {
  BILLING_URL_PATH,
  CREDITS_URL_PATH,
  SETTINGS_URL_PATH,
  TEAM_URL_PATH,
} from '@/routing/paths';

export const useIsOnAllowedPage = () => {
  const isBilling = !!useMatch(BILLING_URL_PATH);
  const isTeam = !!useMatch(TEAM_URL_PATH);
  const isSettings = !!useMatch(SETTINGS_URL_PATH);
  const isCredits = !!useMatch(CREDITS_URL_PATH);

  return isBilling || isTeam || isSettings || isCredits;
};
